import { Button, Tooltip } from 'antd';
import {
  EnvironmentOutlined,
  PauseCircleFilled,
  PlayCircleFilled,
  SelectOutlined,
  UserOutlined,
  PictureOutlined,
} from '@ant-design/icons';
import ReactPlayer from 'react-player';
import React from 'react';
import { useRouter } from 'next/router';
import { getImageVersionUrl } from '../../../lib/images';
import styles from '../css/stylesIndex.module.css';
import Link from '../../shared/elements/Link';
import css from '../css/cards.module.css';
import ZotzonAvatar from '../../shared/elements/images/ZotzonAvatar';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_WIDTH } from '../../../constants';

const CardInst = ({ item, width = '33.3333%', isPrivat = true, showPrice = false }) => {
  const router = useRouter();
  const [videoPlay, setVideoPlay] = React.useState(false);
  const [isHidden, setHidden] = React.useState(false);

  const img = item.covers?.[0] ? getImageVersionUrl({ id: item.covers?.[0].id, version: 'crop' }) : '';

  function toggleHidden() {
    setHidden(!isHidden);
  }

  const videos = [];
  const authorAvatar = item?.authorAvatar || item?.author?.avaterUrl;
  const autorPage = `/users/${item.authorId}`;
  const address = router.locale === 'ru' ? item.locationNameRu : item.locationNameEn;

  const tooltipText = (
    <div>
      <div>{item.authorName}</div>
      <div>
        <EnvironmentOutlined /> {address}
      </div>
    </div>
  );
  return (
    <div
      key={`card${item.id}`}
      style={{
        width: width,
        aspectRatio: '1/1',
        float: 'left',
        overflow: 'hidden',
        border: '1px solid #f0f0f0',
        position: 'relative',
      }}
    >
      {!isPrivat && (
        <div
          className={styles.headerDiv2}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            background: 'rgba(255,255,255,0.8)',
            height: '26px',
            minWidth: '30px',
            padding: '0 5px',
            borderRadius: '0 0 0 10px',
          }}
        >
          <Tooltip title={tooltipText}>
            {authorAvatar && (
              <div>
                <Link className={css.cardAutorlink} href={autorPage}>
                  <ZotzonAvatar
                    className={styles.headerZotzonAvatar}
                    version='small'
                    alt={item.authorName}
                    src={authorAvatar}
                  />
                </Link>
              </div>
            )}
            {!authorAvatar && (
              <div className={styles.headerDiv3}>
                <Link className={css.cardAutorlink} href={autorPage}>
                  <UserOutlined />
                </Link>
              </div>
            )}
          </Tooltip>
        </div>
      )}

      {showPrice && !isPrivat && item.price != 0 && item.price != '0.00' && (
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            background: 'rgba(255,255,255,0.8)',
            height: '23px',
            minWidth: '30px',
            padding: '0 5px',
            paddingTop: '5px',
            borderRadius: '0 10px 0 0',
          }}
        >
          <div style={{ fontSize: '12px' }}>
            {item.price} {item.currency}
          </div>
        </div>
      )}

      {item.covers.length > 1 && (
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            right: '0',
            background: 'rgba(255,255,255,0.8)',
            height: '23px',
            minWidth: '30px',
            padding: '0 5px',
            paddingTop: '5px',
            borderRadius: '10px 0 0 0 ',
          }}
        >
          <PictureOutlined /> {item.covers.length}
        </div>
      )}

      {item.covers.length > 0 && (
        <a href={`/listings/${item.slug}`}>
          <img src={img} alt={item.title} style={{ height: '100%' }} />
        </a>
      )}

      {item.covers.length === 0 && item?.videos?.length >= 0 && (
        <div style={{ position: 'relative', overflow: 'hidden' }}>
          <Button
            onClick={() => {
              router.push(`/listings/${item.slug}`);
            }}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              zIndex: 20,
              border: 'none',
              background: '#fff',
              borderRadius: '0 0 0 10px',
            }}
          >
            <SelectOutlined
              style={{
                fontSize: '18px',
                color: '#555',
              }}
            />
          </Button>
          {videoPlay !== item.videos[0].id && (
            <img
              style={{ width: '100%', aspectRatio: '1/1' }}
              src={`https://customer-ja6fhk6t3y92qtj8.cloudflarestream.com/${item.videos[0].id}/thumbnails/thumbnail.jpg?time=1s&height=500&width=500`}
            />
          )}

          {videoPlay !== item.videos[0].id && (
            <PlayCircleFilled
              onClick={() => {
                setVideoPlay(item.videos[0].id === videoPlay ? false : item.videos[0].id);
              }}
              style={{
                zIndex: 10,
                position: 'absolute',
                top: 'calc(50% - 30px)',
                left: 'calc(50% - 30px)',
                fontSize: '60px',
                color: 'white',
                cursor: 'pointer',
              }}
            />
          )}
          {videoPlay === item.videos[0].id && (
            <PauseCircleFilled
              onClick={() => {
                setVideoPlay(item.videos[0].id === videoPlay ? false : item.videos[0].id);
              }}
              style={{
                zIndex: 10,
                position: 'absolute',
                top: 'calc(50% - 30px)',
                left: 'calc(50% - 30px)',
                fontSize: '60px',
                color: 'white',
                cursor: 'pointer',
              }}
            />
          )}
          {videoPlay === item.videos[0].id && (
            <ReactPlayer
              style={{
                marginTop: 'calc((50% - 30px)*-1)',
                // aspectRatio: '1/1',
              }}
              url={`https://customer-ja6fhk6t3y92qtj8.cloudflarestream.com/${item.videos[0].id}/manifest/video.m3u8`}
              playing={videoPlay === item.videos[0].id}
              // controls={true}
              // light={<img src={`https://customer-ja6fhk6t3y92qtj8.cloudflarestream.com/${item.videos[0].id}/thumbnails/thumbnail.jpg?time=1s&height=500&width=500`} alt='Thumbnail' />}
              width={'100%'}
              height={'100%'}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CardInst;
